import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import Archived from '../components/mainpage/subcomponent/archived'


const MainArchived = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <Archived />
            </div>
        </div>
    )
}

export default MainArchived;